/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { Close, Warning } from '../../Icons';
import styles from './global-messages.module.css';

interface WarningMessageProps {
    MessageBlock: () => JSX.Element;
    isDismissable: boolean;
    dismiss: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function WarningMessage({
    MessageBlock,
    isDismissable = false,
    dismiss,
}: WarningMessageProps): React.ReactElement<WarningMessageProps> {
    return (
        <div className={`${styles.MessagePanel} ${styles.WarningMessage}`}>
            <Warning aspect="1.75rem" />
            <div className={styles.MessagePanelInfo}>
                <MessageBlock />
            </div>
            {isDismissable && (
                <div className={styles.MessagePanelClose} onClick={dismiss}>
                    <Close aspect="1.25rem" />
                </div>
            )}
        </div>
    );
}

export default WarningMessage;
